import { render } from "./myPageView.vue?vue&type=template&id=7884ab40"
import script from "./myPageView.vue?vue&type=script&lang=js"
export * from "./myPageView.vue?vue&type=script&lang=js"

import "./myPageView.vue?vue&type=style&index=0&id=7884ab40&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__